import { create } from 'zustand'

interface DeleteDialog {
  isOpen: boolean
  targetSessionId: string | null
}

interface SessionsState {
  // 搜索关键词
  searchQuery: string
  setSearchQuery: (query: string) => void

  // 删除确认对话框状态
  deleteDialog: DeleteDialog
  setDeleteDialogOpen: (isOpen: boolean, sessionId?: string | null) => void
}

export const useSessionsStore = create<SessionsState>((set) => ({
  // 搜索状态
  searchQuery: '',
  setSearchQuery: (query: string) => set({ searchQuery: query }),

  // 删除对话框状态
  deleteDialog: {
    isOpen: false,
    targetSessionId: null,
  },
  setDeleteDialogOpen: (isOpen: boolean, sessionId?: string | null) =>
    set({
      deleteDialog: {
        isOpen,
        targetSessionId: sessionId ?? null,
      },
    }),
}))
